import styles from './InputSimple.module.scss'
import React, { ReactNode } from "react";
import { FieldDataProvider } from "@/Providers/FieldDataProvider";
import { InertiaFormProps } from "@inertiajs/react";
import InputError from "@/Components/InputError";
import InputLabel from "@/Components/InputLabel";
import { Descendant } from "slate";
import { Product } from "@/types/Products";
import { PlaceSelectProp } from "@/Atoms/Select/PlaceSelect";
import { Partner } from "@/Atoms/Partners";
import { ChildType } from "@/Organisms/Children/Children";
import PersonInput from "@/Templates/Order/Input/Components/PersonInput";
import Practical from "@/types/Practical";
import { Gender } from "@/types/person";
import { Media } from "@/types/Media";

type PersonFieldsProps = {
  user_person_relationship: number;
  email?: string;
  first_name?: string;
  last_name?: string;
  nickname?: string;
  gender?: Gender;
  birth_date?: string;
  birth_place?: PlaceSelectProp;
  deceased_date?: string;
  deceased_place?: PlaceSelectProp;
  additional_persons?: PersonFieldsProps[];
  relation_to_deceased?: string;
  correspondence_address?: Descendant[];
  years_married?: number;
  widower_since_year?: number;
  widower_of?: string;
  life_events?: string;
  quote_headline?: Descendant[];
  partners?: Partner[];
  children?: ChildType[]; // family_members
  profile_image?: Media;
  photos?: Media[];
  practical?: Practical;
  salutation?: Descendant[];
  introductory_text?: Descendant[];
  closing_text?: Descendant[];
  post_funeral_text?: Descendant[];
};

export type FormProps = {
  redirect_back: boolean;
  direct_order: boolean;
  products: Record<string, Product>;
  // products: ProductType[];
  email?: string;
  user_person_relationship: string;
  person: PersonFieldsProps
};

export type RelationToDeceased = 'direct_relative' | 'indirect_relative' | 'undertaker' | 'company';

export default (
  {
    data,
    errors,
    setData,
    relation_to_deceased,
    user_person_relationships,
    footer,
  }: {
    relation_to_deceased: RelationToDeceased
    user_person_relationships: { label: string, value: string }[];
    page: any;
    theme: any;
    onPhotoUpload: (files: File[], category: 'profile') => Promise<void>;
    footer?: ReactNode;
  } & InertiaFormProps<FormProps>
) => {

  const {person} = data;
  const isMain = ['direct_relative', 'undertaker'].includes(relation_to_deceased);

  const setPersonData = (key: string | ((prevPerson: any) => any), value?: any) => {
    if (typeof key === 'function') {
      setData((prevData: any) => ({
        ...prevData,
        person: key(prevData.person),
      }));
      return;
    }

    // @ts-ignore
    setData(`person.${key}`, value)

  }

  // @ts-ignore
  const personErrors = Object.entries(errors).reduce((acc: any, [key, value]) => {
    const prefix = 'person.';
    if (key.startsWith(prefix)) {
      const subKey = key.substring(prefix.length); // strip prefix plus .(dot) from key
      // improve readability of error messages
      value = value.replace('person.', '');
      value = value.replace('practical.', '');
      value = value.replace('.', ' ');
      acc[subKey] = value
    }
    return acc;
  }, {});

  const canCreate = true;
  return <div className={styles.card}>
    <div className={styles.body}>
      <div className={styles.title}>
        <h2>Gegevens overledene</h2>
        <p>Deze gegevens gebruiken we als basis voor de advertentie.</p>
      </div>

      <FieldDataProvider
        fieldData={person as any}>{/* Cast due to difference between Editor FormData and PersonFieldProps*/}
        <div className={styles.fields}>
          <div>
            <InputLabel
              htmlFor="user_person_relationship"
              value="Wat is jouw relatie tot de overledene"
              required
              data-testid={"user_person_relationship"}
            />

            <select
              id={'user_person_relationship'}
              data-testid={'user_person_relationship'}
              value={person.user_person_relationship}
              onChange={(e: any) => setPersonData("user_person_relationship", e.target.value)}
            >
              <option></option>
              {user_person_relationships.map((rel, index) => <option
                key={index}
                value={rel.value}>{rel.label}</option>)}
            </select>
            <InputError message={personErrors.user_person_relationship} className="mt-2" />
          </div>
          <PersonInput
            data={person}
            setData={setPersonData}
            errors={personErrors}
            canCreate={canCreate}
            isMain={isMain}
          />
        </div>
      </FieldDataProvider>
    </div>

    <div className={styles.footer}>
      <p>Velden met een <span className={'color-error font-bold'}>*</span> zijn verplicht. Alle overige velden zijn
        optioneel.</p>
      {footer && <div className={styles.actions}>{footer}</div>}
    </div>
  </div>
}
